import { render, staticRenderFns } from "./ProjectEditForm.vue?vue&type=template&id=5b241ace"
import script from "./ProjectEditForm.vue?vue&type=script&lang=js"
export * from "./ProjectEditForm.vue?vue&type=script&lang=js"
import style0 from "./ProjectEditForm.vue?vue&type=style&index=0&id=5b241ace&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports